import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import ModuleCard from '../components/ModuleCard';
import { initPushNotifications } from '../services/push';
import { logout } from '../services/auth';
import ConfirmButton from '../components/ConfirmButton';
import ProductTour, { tourSeen } from '../components/ProductTour';

const MODULES = [
  { id: '01', name: 'Daily Motivation'  },
  { id: '02', name: 'Athlete Brief'     },
  { id: '03', name: 'Fashion Feed'      },
  { id: '04', name: 'Workout Plan'      },
  { id: '05', name: 'Meal Plans'        },
  { id: '06', name: 'Outfit Combos'     },
  { id: '07', name: 'Deal Finder'       },
  { id: '08', name: 'Income & Budget'   },
];

function Logo() {
  return <img src="/rdl-logo.png" alt="RDL" className="h-10 w-auto" />;
}

export default function Dashboard() {
  const navigate = useNavigate();

  // The dashboard is the first screen after signing in, so the tour starts
  // here rather than over the login form.
  const [tour, setTour] = useState(() => !tourSeen());

  useEffect(() => {
    initPushNotifications();
  }, []);

  const today = format(new Date(), 'EEEE, MMMM d').toUpperCase();

  return (
    <div className="max-w-lg mx-auto px-6 pb-16 safe-top safe-bottom">

      {/* Top nav */}
      <div className="flex items-center justify-between pt-6 pb-8">
        <button onClick={() => navigate('/')} className="hover:opacity-70 transition-opacity">
          <Logo />
        </button>
        <div className="text-right">
          <p className="text-[9px] tracking-[0.25em] uppercase text-gray-500">Morning Brief</p>
          <p className="text-[9px] tracking-[0.2em] uppercase mt-0.5" style={{ color: 'var(--gold)' }}>
            Ready
          </p>
        </div>
      </div>

      {/* Hero text — matches "Miami's Leader In Luxury" style */}
      <div className="border-t border-white/10 pt-8 pb-10">
        <p className="text-[9px] tracking-[0.35em] uppercase text-gray-500 mb-3">
          {today}
        </p>
        <h1 className="text-2xl font-light tracking-[0.12em] uppercase leading-snug">
          Personal<br />
          <span className="font-semibold">Operating System</span>
        </h1>
        <div className="flex items-end justify-between gap-4 mt-3">
          <p className="text-[10px] tracking-[0.2em] uppercase text-gray-500">
            Eight modules · Updated daily
          </p>
          <div className="flex items-center gap-4 shrink-0">
            <button
              onClick={() => navigate('/settings')}
              className="text-[9px] tracking-[0.2em] uppercase text-gray-600 hover:text-white transition-colors"
            >
              Password
            </button>
            <ConfirmButton
              onConfirm={logout}
              label="Sign out"
              confirmLabel="Tap to confirm"
              className="text-[9px] tracking-[0.2em] uppercase transition-colors hover:text-white"
              style={{ color: '#4b5563' }}
              confirmStyle={{ color: 'var(--gold)' }}
            />
          </div>
        </div>
      </div>

      {/* Module list — full-width rows like RD nav */}
      <div className="border-t border-white/10">
        {MODULES.map((mod) => (
          <ModuleCard
            key={mod.id}
            {...mod}
            status="ready"
            to={mod.id === '08' ? '/finance' : undefined}
          />
        ))}
      </div>

      {/* Footer */}
      <p className="text-center text-[9px] tracking-[0.25em] uppercase text-gray-600 mt-12">
        Refreshed overnight · ready by 5:45 AM
      </p>

      {tour && <ProductTour onClose={() => setTour(false)} />}
    </div>
  );
}
